import PredictionPresentation from 'components/organisms/presentations/PredictionPresentation';

const Prediction = () => <PredictionPresentation />;

export default Prediction;
